import { ModalType, LModalContentsWidthType } from '@lib/components';
import { SharesComponent } from './shares.component';
import { ModalBlockParts } from '@lib/services';

export function SharesPayloadParts(): ModalBlockParts {
  return {
    id: 'SharesComponent',
    block: SharesComponent,
    closeBackEnable: true,
    type: ModalType.TYPE2,
    modalWidth: LModalContentsWidthType.MODAL_PC_W768,
    payload: {} as any,
  };
}
